import { message } from 'antd';
import * as API from '@/services/api';

export default {
  namespace: 'hotwords',
  state: {
    hotList: [],
    hotParams: {},
    hotPagination: {}
  },
  effects: {
    *getHotList({ payload }, { call, put, select }) {
      const params = yield select((state) => state.hotwords.hotParams);
      const res = yield call(API.listHot, { ...params, ...payload });
      if (res.code === 0) {
        const data = res.data;
        yield put({
          type: 'save',
          payload: {
            hotList: data.data,
            hotParams: { ...params, ...payload },
            hotPagination: data.pagination,
          },
        });
      }
    },

    *addHot({ payload }, { call, put }) {
      const res = yield call(API.addHot, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getHotList',
        });
      } else {
        message.error(res.message);
      }
    },
    *delHot({ payload }, { call, put }) {
      const res = yield call(API.delHot, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getHotList',
        });
      } else {
        message.error(res.message);
      }
    },
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
};
